<template>
  <div class="modifypwd">
    <div class="modifypwdBox">
      <div class="tips">为确保用户账户安全性，用户首次登录或修改密码后需修改密码！</div>
      <div class="beforeIcon fs16 ftb ftc66">修改密码</div>
      <div class="modifyForm">
        <el-form
          label-width="160px"
          :model="formLabelAlign"
          size="small"
          ref="formLabelAlign"
          :rules="rules"
        >
          <el-form-item label="原密码" prop="pwd">
            <el-input
              v-model="formLabelAlign.pwd"
              style="width: 350px"
              placeholder="请输入"
              type="password"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="newPwd">
            <el-input
              v-model="formLabelAlign.newPwd"
              style="width: 350px"
              placeholder="请输入"
              type="password"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="confirmPwd">
            <el-input
              v-model="formLabelAlign.confirmPwd"
              style="width: 350px"
              placeholder="请输入"
              type="password"
              show-password
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div style="text-align: center; padding-top: 20px">
        <el-button size="small" class="cancelBtn" @click="$router.go(-1)">返回</el-button>
        <el-button size="small" class="sureBtn" @click="submitForm">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { updatePwd } from "@/api/login/index.js";
export default {
  data() {
    var validatepwd = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("原密码不能为空"));
      } else {
        callback();
      }
    };
    var validatenewPwd = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("新密码不能为空"));
      } else {
        if (value == this.formLabelAlign.pwd) {
          callback(new Error("新密码不能和原密码相同"));
        } else {
          // let t1 = /^(?=.*\d)(?=.*[a-z])[a-zA-Z0-9]{6,12}$/;
          let t1 = /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)(?=.*?[!#@*&.])[a-zA-Z\d!#@*&.]{8,}$/
          if (t1.test(value)) {
            callback();
          } else {
            callback(new Error("密码不能少于8位,且必须有数字、大小写字母、特殊字符组合"));
          }
        }
      }
    };
    var validateconfirmPwd = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("确认密码不能为空"));
      } else {
        if (value != this.formLabelAlign.newPwd) {
          callback(new Error("两次密码不一致,请重新输入"));
        } else {
          callback();
        }
      }
    };
    return {
      formLabelAlign: {
        pwd: "",
        newPwd: "",
        confirmPwd: "",
      },
      rules: {
        pwd: [
          {
            required: true,
            validator: validatepwd,
            trigger: "blur",
          },
        ],
        newPwd: [
          {
            required: true,
            validator: validatenewPwd,
            trigger: "blur",
          },
        ],
        confirmPwd: [
          {
            required: true,
            validator: validateconfirmPwd,
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    submitForm() {
      this.$refs.formLabelAlign.validate((volid) => {
        if (volid) {
          updatePwd(this.formLabelAlign).then((res) => {
            if (res.data.code == 1) {
              this.$message({
                type: "success",
                message: "修改成功，需重新登录！",
              });
              this.$router.push({
                path: "/home/homepage"
              });
              sessionStorage.clear()
              localStorage.clear()
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.modifypwd {
  width: 100%;
  height: 100%;
  background-color: #fff !important;
}

.modifypwdBox {
  padding: 20px 0;
  width: 600px;
  margin: 0 auto;
}

.modifyForm {
  padding-top: 20px;
}

.cancelBtn {
  width: 90px;
  height: 32px;
  border-radius: 5px;
}

.sureBtn {
  width: 90px;
  height: 32px;
  background: #15d393;
  border-radius: 5px;
  border: none;
  color: #fff;
}
.tips {
  color: red;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/modifypwdFirst/modifypwd.vue